import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';
import grey from '@material-ui/core/colors/grey';
import amber from '@material-ui/core/colors/amber';

import {
  Filter,
  FilterButton,
  FilterDivider,
  FilterItem,
} from 'components/core/Filter';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import { startEditReceiptListFilter } from '../../../store/actions/filters';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    marginLeft: theme.spacing.unit*4,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  },
});

const ReceiptsFilter = (props) => {
  const {
    classes,
    help,
    handleAdd,
    receiptListFilter,
    startEditReceiptListFilter
  } = props;

  return(
    <div className={classes.root}>
      <Filter>
        <FilterItem>
          <FilterButton
            selected={receiptListFilter.type === "all"}
            onClick={() => startEditReceiptListFilter({type: "all"})}>
            All
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Filter">
          <FilterButton
            selected={receiptListFilter.type === "invoiced"}
            onClick={() => startEditReceiptListFilter({type: "invoiced"})}>
            Invoiced
          </FilterButton>
          <FilterButton
            selected={receiptListFilter.type === "not-invoiced"}
            onClick={() => startEditReceiptListFilter({type: "not-invoiced"})}>
            Not Invoiced
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Sort">
          <FilterButton
            selected={receiptListFilter.orderBy === "date"}
            onClick={() => {
              let direction = "desc";
              if (receiptListFilter.orderBy === "date") {
                direction = receiptListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditReceiptListFilter({orderBy: "date", direction: direction})
            }}>
            Date
          </FilterButton>
          <FilterButton
            selected={receiptListFilter.orderBy === "client"}
            onClick={() => {
              let direction = "desc";
              if (receiptListFilter.orderBy === "client") {
                direction = receiptListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditReceiptListFilter({orderBy: "client", direction: direction})
            }}>
            Client
          </FilterButton>
          <FilterButton
            selected={receiptListFilter.orderBy === "status"}
            onClick={() => {
              let direction = "desc";
              if (receiptListFilter.orderBy === "status") {
                direction = receiptListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditReceiptListFilter({orderBy: "status", direction: direction})
            }}>
            Status
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem hideCaption>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={receiptListFilter.showArchived}
                onChange={() => {
                  startEditReceiptListFilter({showArchived: !receiptListFilter.showArchived})
                }}
              />
            }
            label="SHOW ARCHIVED"
          />
        </FilterItem>
      </Filter>
      <Tooltip type={TooltipTypes.receipt.ADD} placement="left">
        <Button
          className={classNames(classes.addButton, help.isCurrentStep(TooltipTypes.receipt.ADD) && classes.elevate)}
          variant="fab"
          aria-label="add"
          onClick={() => {
            helpDispatch(TooltipTypes.receipt.ADD);
            handleAdd();
          }}
        >
          <AddIcon />
        </Button>
      </Tooltip>
    </div>
  );
};

ReceiptsFilter.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
  const receiptListFilter = state.filters.receiptList ? state.filters.receiptList : {};

  return({
    receiptListFilter,
    help: state.help,
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditReceiptListFilter: (updates) => dispatch(startEditReceiptListFilter(updates)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ReceiptsFilter);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptsFilter.jsx